import { Component, Inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { COUNTRY_CODE_PATTERNS } from 'src/app/common/utils/phone-formatter.util';

const ISO_TO_ENTRY = new Map(COUNTRY_CODE_PATTERNS.filter(p => p.iso).map(p => [p.iso!, p]));

export interface LoginOptionsConfirmData {
  config: {
    phoneOtpEnabled: boolean;
    emailOtpEnabled: boolean;
    emailPasswordEnabled: boolean;
    googleEnabled: boolean;
    appleEnabled: boolean;
    batSsoEnabled: boolean;
    defaultLoginMethod: string | null;
    allowedCountryCodes: string;
  };
  isUsingDefault: boolean;
}

@Component({
  selector: 'app-login-options-confirm-dialog',
  templateUrl: './advertiser-login-options-confirm-dialog.component.html',
  standalone: true,
  imports: [CommonModule, MatDialogModule, MatButtonModule, MatIconModule],
})
export class AdvertiserLoginOptionsConfirmDialogComponent {
  constructor(
    public dialogRef: MatDialogRef<AdvertiserLoginOptionsConfirmDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: LoginOptionsConfirmData
  ) {}

  get allowedCodesLabel(): string {
    const raw = this.data.config.allowedCountryCodes?.trim();
    if (!raw) return 'All countries';
    return raw
      .split(',')
      .map(c => c.trim().toUpperCase())
      .filter(c => c.length > 0)
      .map(c => {
        const entry = ISO_TO_ENTRY.get(c);
        if (!entry) return c;
        return entry.country ? `${c} (+${entry.code}, ${entry.country})` : `${c} (+${entry.code})`;
      })
      .join(', ');
  }
}
